<div class="clear-spacing"></div>
<div class="row">
  <div class="col-md-12">
    <div class="row">
      <div class="col-md-12">
        <div *ngIf="currentPlan === 'TTPLUS'" class="alert alert-success" style="text-align: center;">
          <span [innerHTML]="'AccountSettings.changePlanPlusPlanViewChanges' | translate | htmlSafe"></span>
          <span *ngIf="configList['showTimeTapSupportNumber']">Give our support line a call at 202-753-7351</span>
          <span *ngIf="!configList['showTimeTapSupportNumber']">Reach out to us with your questions at <a
            href="mailto:support@timetap.com" target="_blank">support&#64;timetap.com</a></span>
        </div>
        <div *ngIf="legacyPlan" class="alert alert-success" style="text-align: center;">
          <strong>We've made some changes to our plans!</strong><br>
          You are currently on one of our legacy plans which is not shown in the table below. You can
          continue using this plan for as long as you'd like with all the same features and functionality.
          Take a look below and feel free to switch to one of our new plans if that makes more sense for
          your business. Please keep in mind that if you do switch to one of our new plans you may not
          have the opportunity to switch back to the legacy plan you are on now. Have questions? <span
          *ngIf="configList['showTimeTapSupportNumber']">Give our support line a call at 202-753-7351</span>
          <span *ngIf="!configList['showTimeTapSupportNumber']">Reach out to us with your questions at
                          <a href="mailto:support@timetap.com" target="_blank">support&#64;timetap.com</a>
                        </span>
        </div>
        <div *ngIf="currentPlan === 'TTFREE' && allowFreeTrial" class="alert alert-warning"
             style="text-align: center;"
             [innerHTML]="'AccountSettings.changePlanFreeTrialFreeActPrompt' | translate | htmlSafe">
        </div>
      </div>

    </div>
    <div class="clearfix clear-spacing" *ngIf="currentPlan === 'TTFREE' && allowFreeTrial"></div>
    <div class="row">
      <div class="col-md-10 offset-md-1 col-sm-10 offset-sm-1 col-xs-10 offset-xs-1">
        <div class="annual-monthly-toggle" *ngIf="planVertical === 'general'"><!--Recruiter plans-->
          <button (click)="changeActiveView('ANNUAL')" class="btn btn-default annual"
                  [ngClass]="{'btn-success': activeView === 'ANNUAL'}">
            Annual
          </button>
          <button (click)="changeActiveView('MONTHLY')"
                  class="btn btn-default monthly" [ngClass]="{'btn-success': activeView === 'MONTHLY'}">
            Monthly
          </button>
        </div>
      </div>
    </div>
    <div class="clearfix clear-spacing"></div>
    <div class="row">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <div class="row pricing-comparison-head">
          <div
            class="col-md-4 offset-md-2 col-sm-4 offset-sm-2 col-xs-4 offset-xs-2 plans-table-header pricing-head text-center professional"
            *ngIf="planVertical === 'general'">
            <h3>Professional
              <br>
              <span [innerHTML]="'AccountSettings.changePlansProSubtitle' | translate | htmlSafe"></span>
            </h3>
          </div>
          <div class="plans-table-header pricing-head text-center business"
               [ngClass]="{'col-md-4 col-sm-4 col-xs-4': planVertical === 'general', 'col-md-10 offset-md-2 col-sm-10 offset-sm-2 col-xs-10 offset-xs-2': planVertical === 'recruiter'}">
            <h3 *ngIf="planVertical === 'general'">Business
              <br>
              <span [innerHTML]="'AccountSettings.changePlansBizSubtitle' | translate | htmlSafe "></span>
            </h3>
            <h3 *ngIf="planVertical === 'recruiter'">Recruiter Plans
              <br>
              <span>Plans customized for managing {{ configList['clientLabelPlural'] }} through the interview scheduling process</span>
            </h3>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <div class="row">
          <div
            class="col-md-2 offset-md-2 col-sm-2 offset-sm-2 col-xs-2 offset-xs-2 plans-table-header pricing-head plan-name text-center"
            *ngIf="planVertical === 'general'">
            <h3>Solo</h3>
            <p class="current-plan-badge">
                        <span class="badge"
                              [ngClass]="{'badge-clear': currentPlan !== 'SOLOPRO' || (currentPlan === 'SOLOPRO' && activeView !== planFrequency)}">
                            <span *ngIf="currentPlan === 'SOLOPRO'">Gives more organization and efficiency in your scheduling process <div
                              class='show-pricing-header-padding-professional'><br>&nbsp;</div></span>
                        </span>
            </p>
            <span>1 {{ configList['staffLabel'] }} + 1 {{ configList['locationLabel'] }}</span>
            <h4><i>$</i>{{ pricing.soloProfessionalPlan }}.<i *ngIf="activeView === 'ANNUAL'">45</i><i
              *ngIf="activeView === 'MONTHLY'">45</i>
              <p>
                            <span>
                                Per Month <span *ngIf="activeView === 'ANNUAL'" style="font-size: 10px;"><em>(paid annually)</em></span>
                            </span>
              </p>
            </h4>
            <!-- CASE 1: On Free plan has not done free trial yet -->
            <!--START FREE TRIAL BUTTON-->
            <button (click)="switchPlans(soloProPlan, 'freetrial')" class="btn btn-success"
                    *ngIf="allowFreeTrial && currentPlan === 'TTFREE'">
              Start Free Trial <i class="m-icon-swapright m-icon-white"></i>
            </button>
            <!-- CASE 2: On Free Trial of SOLOPRO (or trial is suspended) - Downgrade under TTFREE, Show update billing info button for SOLOPRO, Switch option for TEAMPRO/SOLOBUS/TEAMBUS -->
            <!--UPDATE BILLING BUTTON-->
            <button class="btn btn-success"
                    *ngIf="!allowFreeTrial && currentPlan === 'SOLOPRO' && !business.billingInfoAdded && activeView === planFrequency">
              Update Billing Info <i class="m-icon-swapright m-icon-white"></i>
            </button>
            <!--CASE 3: On Free Trial of TEAMPRO (or trial is suspended) - Downgrade under TTFREE, Show switch to SOLOPRO/SOLOBUS/TEAMBUS button, update billing info for TEAMPRO-->
            <!-- CASE 4: On Free Trial of SOLOBUS (or trial is suspended) - Downgrade under TTFREE, Switch option for SOLOPRO/TEAMPRO/TEAMBUS, Show update billing info button for SOLOBUS -->
            <!-- CASE 5: On Free Trial of TEAMBUS (or trial is suspended) - Downgrade under TTFREE, Show switch to SOLOPRO/TEAMPRO/SOLOBUS button, update billing info for TEAMPRO-->
            <!-- CASE 7: Subscribed to TEAMPRO - Downgrade under TTFREE/SOLOPRO, Upgrade under SOLOBUS/TEAMBUS, No button under TEAMPRO -->
            <!-- CASE 8: Subscribed to SOLOBUS  - Downgrade under TTFREE/SOLOPRO/TEAMPRO, No button under SOLOBUS, Upgrade under TEAMBUS -->
            <!-- CASE 9: Subscribed to TEAMBUS - Downgrade under TTFREE/SOLOPRO/TEAMPRO/SOLOBUS No button under TEAMBUS -->
            <!--CHANGE PLANS BUTTON-->
            <button (click)="switchPlans(soloProPlan,  'upgrade')" class="btn btn-secondary"
                    *ngIf="(currentPlan!=='SOLOPRO' && !allowFreeTrial) || (currentPlan === 'SOLOPRO' && activeView !== planFrequency && !business.billingInfoAdded)">
              Change Plans <i class="m-icon-swapright m-icon"></i>
            </button>
            <!-- CASE 6: Subscribed to SOLOPRO  - Downgrade under TTFREE, No button under SOLOPRO, Upgrade under TEAMPRO/SOLOBUS/TEAMBUS -->
            <!-- NO BUTTON-->
            <p style="padding-bottom: 18px;"
               *ngIf="currentPlan === 'SOLOPRO' && business.billingInfoAdded && activeView === planFrequency">
              &nbsp;</p>
            <!--Subscribed to SOLOPRO but on Annual plan and looking at Monthly view (or vice versa)-->
            <!--BUTTON READS "SWITCH TO MONTHLY" OR "SWITCH TO ANNUAL" DEPENDING-->
            <button (click)="switchPlans(soloProPlan, 'upgrade')" class="btn btn-secondary"
                    *ngIf="currentPlan === 'SOLOPRO' && business.billingInfoAdded && activeView !== planFrequency">
              Switch to {{ activeView }} <i class="m-icon-swapright m-icon"></i>
            </button>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 plans-table-header pricing-head plan-name text-center"
               *ngIf="planVertical === 'general'">
            <h3>Team</h3>
            <p class="current-plan-badge">
                        <span class="badge"
                              [ngClass]="{'badge-clear': currentPlan !== 'TEAMPRO' || (currentPlan === 'TEAMPRO' && activeView !== planFrequency)}">
                            <span
                              *ngIf="currentPlan === 'TEAMPRO'">{{ "AccountSettings.changePlansCurrentPlan" }}</span>
                        </span>
            </p>
            <span>5 {{ configList['staffLabel'] }} + 5 {{ configList['locationLabelPlural'] }}</span>
            <h4><i>$</i>{{ pricing.teamProfessionalPlan }}.<i>95</i>
              <p>
                            <span [innerHTML]="'AccountSettings.changePlansBasicPerMonth' | translate | htmlSafe"><span
                              *ngIf="activeView === 'ANNUAL'"
                              style="font-size: 10px;"><em>(paid annually)</em></span>
                            </span>
              </p>
            </h4>
            <!-- CASE 1: On Free plan has not done free trial yet -->
            <!--START FREE TRIAL BUTTON-->
            <button (click)="switchPlans(teamProPlan,  'freetrial')" class="btn btn-success"
                    *ngIf="allowFreeTrial && currentPlan === 'TTFREE'">
              Start Free Trial <i class="m-icon-swapright m-icon-white"></i>
            </button>
            <!-- CASE 2: On Free Trial of SOLOPRO (or trial is suspended) - Downgrade under TTFREE, Show update billing info button for SOLOPRO, Switch option for TEAMPRO/SOLOBUS/TEAMBUS -->
            <!-- CASE 4: On Free Trial of SOLOBUS (or trial is suspended) - Downgrade under TTFREE, Switch option for SOLOPRO/TEAMPRO/TEAMBUS, Show update billing info button for SOLOBUS -->
            <!-- CASE 5: On Free Trial of TEAMBUS (or trial is suspended) - Downgrade under TTFREE, Show switch to SOLOPRO/TEAMPRO/SOLOBUS button, update billing info for TEAMPRO-->
            <!-- CASE 6: Subscribed to SOLOPRO  - Downgrade under TTFREE, No button under SOLOPRO, Upgrade under TEAMPRO/SOLOBUS/TEAMBUS -->
            <!-- CASE 9: Subscribed to TEAMBUS - Downgrade under TTFREE/SOLOPRO/TEAMPRO/SOLOBUS No button under TEAMBUS -->
            <!--CHANGE PLANS BUTTON-->
            <button (click)="switchPlans(teamProPlan, 'upgrade')" class="btn btn-secondary"
                    *ngIf="(currentPlan!=='TEAMPRO' && !allowFreeTrial) || (currentPlan === 'TEAMPRO' && activeView !== planFrequency && !business.billingInfoAdded)">
              Change Plans <i class="m-icon-swapright m-icon"></i>
            </button>
            <!--CASE 3: On Free Trial of TEAMPRO (or trial is suspended) - Downgrade under TTFREE, Show switch to SOLOPRO/SOLOBUS/TEAMBUS button, update billing info for TEAMPRO-->
            <!--UPDATE BILLING BUTTON-->
            <button ui-sref="account-billing" class="btn btn-success"
                    *ngIf="!allowFreeTrial && currentPlan === 'TEAMPRO' && !business.billingInfoAdded && activeView === planFrequency">
              Update Billing Info <i class="m-icon-swapright m-icon-white"></i>
            </button>
            <!-- CASE 7: Subscribed to TEAMPRO - Downgrade under TTFREE/SOLOPRO, Upgrade under SOLOBUS/TEAMBUS, No button under TEAMPRO -->
            <!-- NO BUTTON-->
            <p style="padding-bottom: 18px;"
               *ngIf="currentPlan === 'TEAMPRO' && business.billingInfoAdded && activeView === planFrequency">
              &nbsp;</p>
            <!--Subscribed to TEAMPRO but on Annual plan and looking at Monthly view (or vice versa)-->
            <!--BUTTON READS "SWITCH TO MONTHLY" OR "SWITCH TO ANNUAL" DEPENDING-->
            <button (click)="switchPlans(teamProPlan, 'upgrade')" class="btn btn-secondary"
                    *ngIf="currentPlan === 'TEAMPRO' && business.billingInfoAdded && activeView !== planFrequency">
              Switch to {{ activeView }} <i class="m-icon-swapright m-icon"></i>
            </button>
          </div>
          <div class=" plans-table-header pricing-head plan-name text-center"
               [ngClass]="{'col-md-2 col-sm-2 col-xs-2': planVertical === 'general', 'col-md-5 offset-md-2 col-sm-5 offset-sm-2 col-xs-5 offset-xs-2': planVertical === 'recruiter'}">
            <h3 *ngIf="planVertical === 'general'">Solo</h3>
            <h3 *ngIf="planVertical === 'recruiter'">Monthly</h3>
            <p class="current-plan-badge" *ngIf="planVertical === 'general'">
                        <span class="badge"
                              [ngClass]="{'badge-clear': currentPlan !== 'SOLOBUS' || (currentPlan === 'SOLOBUS' && activeView !== planFrequency)}">
                            <span
                              *ngIf="currentPlan === 'SOLOBUS'">{{ "AccountSettings.changePlansCurrentPlan" }}</span>
                        </span>
            </p>
            <p class="current-plan-badge" *ngIf="planVertical === 'recruiter'">
                        <span class="badge" [ngClass]="{'badge-clear': currentPlan !== 'RECRUITERMONTHLY'}">
                            <span
                              *ngIf="currentPlan === 'RECRUITERMONTHLY'">{{ "AccountSettings.changePlansCurrentPlan" }}</span>
                        </span>
            </p>
            <span *ngIf="planVertical === 'general'">1 {{ configList['staffLabel'] }}
              + 1 {{ configList['locationLabel'] }}</span>
            <h4 *ngIf="planVertical === 'general'">
              <i>$</i>{{ pricing.soloBusinessPlan }}.<i *ngIf="activeView === 'ANNUAL'">45</i><i
              *ngIf="activeView === 'MONTHLY'">95</i>
              <p>
                            <span [innerHTML]="'AccountSettings.changePlansBasicPerMonth' | translate | htmlSafe">
                              <span *ngIf="activeView === 'ANNUAL'"
                                    style="font-size: 10px;"><em>(paid annually)</em></span>
                            </span>
              </p>
            </h4>
            <h4 *ngIf="planVertical === 'recruiter'">
              <i>$</i>25.<i>00</i>
              <p>
                            <span>
                                Per {{ configList['staffLabel'] }} {{ "AccountSettings.changePlansBasicPerMonth" }}</span>

              </p>
            </h4>
            <!-- CASE 1: On Free plan has not done free trial yet -->
            <!--START FREE TRIAL BUTTON-->
            <button (click)="switchPlans(soloBizPlan, 'freetrial')" class="btn btn-success"
                    *ngIf="planVertical === 'general' && allowFreeTrial && currentPlan === 'TTFREE'">
              Start Free Trial <i class="m-icon-swapright m-icon-white"></i>
            </button>
            <!-- CASE 2: On Free Trial of SOLOPRO (or trial is suspended) - Downgrade under TTFREE, Show update billing info button for SOLOPRO, Switch option for TEAMPRO/SOLOBUS/TEAMBUS -->
            <!--CASE 3: On Free Trial of TEAMPRO (or trial is suspended) - Downgrade under TTFREE, Show switch to SOLOPRO/SOLOBUS/TEAMBUS button, update billing info for TEAMPRO-->
            <!--CASE 5: On Free Trial of TEAMBUS (or trial is suspended) - Downgrade under TTFREE, Show switch to SOLOPRO/TEAMPRO/SOLOBUS button, update billing info for TEAMPRO-->
            <!-- CASE 6: Subscribed to SOLOPRO  - Downgrade under TTFREE, No button under SOLOPRO, Upgrade under TEAMPRO/SOLOBUS/TEAMBUS -->
            <!-- CASE 9: Subscribed to TEAMBUS - Downgrade under TTFREE/SOLOPRO/TEAMPRO/SOLOBUS No button under TEAMBUS -->
            <!--CHANGE PLANS BUTTON-->
            <button (click)="switchPlans(soloBizPlan, 'upgrade')" class="btn btn-secondary"
                    *ngIf="planVertical === 'general' && (currentPlan!=='SOLOBUS' && !allowFreeTrial) || (currentPlan === 'SOLOBUS' && activeView !== planFrequency && !business.billingInfoAdded)">
              Change Plans <i class="m-icon-swapright m-icon"></i>
            </button>
            <!-- CASE 4: On Free Trial of SOLOBUS (or trial is suspended) - Downgrade under TTFREE, Switch option for SOLOPRO/TEAMPRO/TEAMBUS, Show update billing info button for SOLOBUS -->
            <!--UPDATE BILLING BUTTON-->
            <button class="btn btn-success"
                    *ngIf="planVertical === 'general' && (!allowFreeTrial && currentPlan === 'SOLOBUS' && !business.billingInfoAdded && activeView === planFrequency)">
              <span>Update Billing Info</span> <i class="m-icon-swapright m-icon-white"></i>
            </button>
            <!-- CASE 8: Subscribed to SOLOBUS  - Downgrade under TTFREE/SOLOPRO/TEAMPRO, No button under SOLOBUS, Upgrade under TEAMBUS -->
            <!-- NO BUTTON-->
            <p style="padding-bottom: 18px;"
               *ngIf="planVertical === 'general' && currentPlan === 'SOLOBUS' && business.billingInfoAdded && activeView === planFrequency">
              &nbsp;</p>
            <!--Subscribed to SOLOBUS but on Annual plan and looking at Monthly view (or vice versa)-->
            <!--BUTTON READS "SWITCH TO MONTHLY" OR "SWITCH TO ANNUAL" DEPENDING-->
            <button (click)="switchPlans(soloBizPlan, 'upgrade')" class="btn btn-secondary"
                    *ngIf="(currentPlan === 'SOLOBUS' && business.billingInfoAdded && activeView !== planFrequency)">
              Switch to {{ activeView | titlecase }} <i class="m-icon-swapright m-icon"></i>
            </button>
            <!--CASE ON RECRUITER PLANS -->
            <!--ON RECRUITER ANNUAL PLAN-->
            <button (click)="switchPlans(recruiterMonthlyPlan, 'upgrade')" class="btn btn-secondary"
                    *ngIf="planVertical === 'recruiter' && (currentPlan!=='RECRUITERMONTHLY' && !allowFreeTrial)">
              Change Plans <i class="m-icon-swapright m-icon"></i>
            </button>
            <!--ON FREE TRIAL OF RECRUITER MONTHLY PLAN-->
            <button class="btn btn-success"
                    *ngIf="planVertical === 'recruiter' && (!allowFreeTrial && currentPlan === 'RECRUITERMONTHLY' && !business.billingInfoAdded)">
              <span>Update Billing Info</span> <i class="m-icon-swapright m-icon-white"></i>
            </button>
            <!--SUBSCRIBED TO RECRUITER MONTHLY PLAN WITH BILLING INFO IN PLACE-->
            <p style="padding-bottom: 18px;"
               *ngIf="planVertical === 'recruiter' && (currentPlan === 'RECRUITERMONTHLY' && business.billingInfoAdded)">
              &nbsp;</p>
          </div>
          <div class="plans-table-header pricing-head plan-name text-center"
               [ngClass]="{'col-md-2 col-sm-2 col-xs-2': planVertical === 'general', 'col-md-5 col-sm-5 col-xs-5': planVertical === 'recruiter'}">
            <h3 *ngIf="planVertical === 'general'">Team</h3>
            <h3 *ngIf="planVertical === 'recruiter'">Annual</h3>
            <p class="current-plan-badge" *ngIf="planVertical === 'general'">
                        <span class="badge"
                              [ngClass]="{'badge-clear': currentPlan !== 'TEAMBUS' || (currentPlan === 'TEAMBUS' && activeView !== planFrequency)}">
                            <span
                              *ngIf="currentPlan === 'TEAMBUS' && activeView === planFrequency">{{ "AccountSettings.changePlansCurrentPlan" | translate }}</span>
                        </span>
            </p>
            <p class="current-plan-badge" *ngIf="planVertical === 'recruiter'">
                        <span class="badge" [ngClass]="{'badge-clear': currentPlan !== 'RECRUITERANNUAL'}">
                            <span
                              *ngIf="currentPlan === 'RECRUITERANNUAL'">{{ "AccountSettings.changePlansCurrentPlan" | translate }}</span>
                        </span>
            </p>
            <span *ngIf="planVertical === 'general'">5 {{ configList['staffLabelPlural'] }}
              + 5 {{ configList['locationLabelPlural'] }}</span>
            <h4 *ngIf="planVertical === 'general'">
              <i>$</i>{{ pricing.teamBusinessPlan }}.<i *ngIf="activeView === 'ANNUAL'">45</i><i
              *ngIf="activeView === 'MONTHLY'">45</i>
              <p>
                            <span>
                                {{ "AccountSettings.changePlansBasicPerMonth" | translate }} <span
                              *ngIf="activeView === 'ANNUAL'"
                              style="font-size: 10px;"><em>(paid annually)</em></span>
                            </span>
              </p>
            </h4>
            <h4 *ngIf="planVertical === 'recruiter'">
              <i>$</i>22.<i>50</i>
              <p>
                            <span>
                                Per {{ configList['staffLabel'] }} /mo <span *ngIf="activeView === 'ANNUAL'"
                                                                             style="font-size: 10px;"><em>(paid annually)</em></span>
                            </span>
              </p>
            </h4>
            <!-- CASE 1: On Free plan has not done free trial yet -->
            <button (click)="switchPlans(teamBizPlan, 'freetrial')" class="btn btn-success"
                    *ngIf="planVertical === 'general' && allowFreeTrial && currentPlan === 'TTFREE'">
              Start Free Trial <i class="m-icon-swapright m-icon-white"></i>
            </button>
            <!-- CASE 2: On Free Trial of SOLOPRO (or trial is suspended) - Downgrade under TTFREE, Show update billing info button for SOLOPRO, Switch option for TEAMPRO/SOLOBUS/TEAMBUS -->
            <!--CASE 3: On Free Trial of TEAMPRO (or trial is suspended) - Downgrade under TTFREE, Show switch to SOLOPRO/SOLOBUS/TEAMBUS button, update billing info for TEAMPRO-->
            <!-- CASE 4: On Free Trial of SOLOBUS (or trial is suspended) - Downgrade under TTFREE, Switch option for SOLOPRO/TEAMPRO/TEAMBUS, Show update billing info button for SOLOBUS -->
            <!-- CASE 6: Subscribed to SOLOPRO  - Downgrade under TTFREE, No button under SOLOPRO, Upgrade under TEAMPRO/SOLOBUS/TEAMBUS -->
            <!--CHANGE PLANS BUTTON-->
            <button (click)="switchPlans(teamBizPlan, 'upgrade')" class="btn btn-secondary"
                    *ngIf="planVertical === 'general' && (currentPlan!=='TEAMBUS' && !allowFreeTrial) || (currentPlan === 'TEAMBUS' && activeView !== planFrequency && !business.billingInfoAdded)">
              Change Plans <i class="m-icon-swapright m-icon"></i>
            </button>
            <!--CASE 5: On Free Trial of TEAMBUS (or trial is suspended) - Downgrade under TTFREE, Show switch to SOLOPRO/TEAMPRO/SOLOBUS button, update billing info for TEAMPRO-->
            <!--UPDATE BILLING BUTTON-->
            <button class="btn btn-success"
                    *ngIf="planVertical === 'general' && (!allowFreeTrial && currentPlan === 'TEAMBUS' && !business.billingInfoAdded && activeView === planFrequency)">
              Update Billing Info <i class="m-icon-swapright m-icon-white"></i>
            </button>
            <!-- CASE 9: Subscribed to TEAMBUS - Downgrade under TTFREE/SOLOPRO/TEAMPRO/SOLOBUS No button under TEAMBUS -->
            <!-- NO BUTTON-->
            <p style="padding-bottom: 18px;"
               *ngIf="planVertical === 'general' && currentPlan === 'TEAMBUS' && business.billingInfoAdded && activeView === planFrequency">
              &nbsp;</p>
            <!--Subscribed to TEAMBUS but on Annual plan and looking at Monthly view (or vice versa)-->
            <!--BUTTON READS "SWITCH TO MONTHLY" OR "SWITCH TO ANNUAL" DEPENDING-->
            <button (click)="switchPlans(teamBizPlan, 'upgrade')" class="btn btn-secondary"
                    *ngIf="(currentPlan === 'TEAMBUS' && business.billingInfoAdded && activeView !== planFrequency)">
              Switch to {{ activeView }} <i class="m-icon-swapright m-icon"></i>
            </button>
            <!--CASE ON RECRUITER PLANS -->
            <!--ON RECRUITER ANNUAL PLAN-->
            <button (click)="switchPlans(recruiterAnnualPlan, 'upgrade')" class="btn btn-secondary"
                    *ngIf="planVertical === 'recruiter' && (currentPlan!=='RECRUITERANNUAL' && !allowFreeTrial)">
              Change Plans <i class="m-icon-swapright m-icon"></i>
            </button>
            <!--ON FREE TRIAL OF RECRUITER MONTHLY PLAN-->
            <button class="btn btn-success"
                    *ngIf="planVertical === 'recruiter' && (!allowFreeTrial && currentPlan === 'RECRUITERANNUAL' && !business.billingInfoAdded)">
              <span>Update Billing Info</span> <i class="m-icon-swapright m-icon-white"></i>
            </button>
            <!--SUBSCRIBED TO RECRUITER MONTHLY PLAN WITH BILLING INFO IN PLACE-->
            <p style="padding-bottom: 18px;"
               *ngIf="planVertical === 'recruiter' || (currentPlan === 'RECRUITERANNUAL' && business.billingInfoAdded)">
              &nbsp;</p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <!--NUMBER OF STAFF ALLOWED PER PLAN-->
      <div class="col-md-12 col-sm-12 col-xs-12 pricing-table-comparison-rows"
           *ngIf="planVertical==='general'">
        <div class="row">
          <div class="col-md-2 col-sm-2 col-xs-2 pricing-table-comparison-cells">
            <label class="tooltip-label"
                   matTooltip="Staff members can have hours of availability which clients use to reserve 1-on-1 appointments. Staff can also be assigned as leading a class which can be offered to multiple clients at one time. Appointment and class availability is defined on a per staff basis so the staff do not all have to be working the same hours.">
              Extra 5 {{ configList['staffLabelPlural'] | titlecase }}:
            </label>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-times-circle error-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
                        <span class="pricing-text">
                            ${{ pricing.teamProfessionalAddOns }}/mo
                        </span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-times-circle error-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
                        <span class="pricing-text">
                            ${{ pricing.teamBusinessAddOns }}/mo
                        </span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <!--NUMBER OF LOCATIONS ALLOWED PER PLAN-->
      <div class="col-md-12 col-sm-12 col-xs-12 pricing-table-comparison-rows"
           *ngIf="planVertical==='general'">
        <div class="row">
          <div class="col-md-2 col-sm-2 col-xs-2 pricing-table-comparison-cells">
            <label class="tooltip-label"
                   matTooltip="Locations are where an appointment takes place at. This could be either be a physical place like your office or a virtual meeting space like Zoom or over the phone. For some businesses, the location will be your clients’ address (1 location can account for all of your clients’ addreses).">
              Extra 5 {{ configList['locationLabelPlural'] | titlecase }}:
            </label>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-times-circle error-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
                        <span class="pricing-text">
                            ${{ pricing.teamProfessionalAddOns }}/mo
                        </span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-times-circle error-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
                        <span class="pricing-text">
                            ${{ pricing.teamBusinessAddOns }}/mo
                        </span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <!--NUMBER OF APPOINTMENTS ALLOWED PER PLAN-->
      <div class="col-md-12 col-sm-12 col-xs-12 pricing-table-comparison-rows"
           *ngIf="planVertical==='general'">
        <div class="row">
          <div class="col-md-2 col-sm-2 col-xs-2 pricing-table-comparison-cells">
            <label class="tooltip-label"
                   matTooltip="Each plan type allows for an unlimited number of appointments per month on each of your staff’s calendars. These can be for 1-on-1 service based appointments or group/class based appointments."
                   [innerHTML]="'AccountSettings.changePlanTableUnlimitedApptsLabel' | translate | htmlSafe">

            </label>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <!--NUMBER OF CLASSES ALLOWED PER PLAN-->
      <div class="col-md-12 col-sm-12 col-xs-12 pricing-table-comparison-rows"
           *ngIf="planVertical==='general'">
        <div class="row">
          <div class="col-md-2 col-sm-2 col-xs-2 pricing-table-comparison-cells">
            <label class="tooltip-label"
                   matTooltip="The Starter (Free) plan only allows you to add 1 type of class to your account. The Professional accounts let you have as many classes as you’d like, each with their own schedules."
                   [innerHTML]="'AccountSettings.changePlanTableUnlimitedClassesLabel' | translate | htmlSafe">
            </label>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <!--ABILITY TO ACCEPT PAYMENTS FOR APPOINTMENTS-->
      <div class="col-md-12 col-sm-12 col-xs-12 pricing-table-comparison-rows"
           *ngIf="planVertical==='general'">
        <div class="row">
          <div class="col-md-2 col-sm-2 col-xs-2 pricing-table-comparison-cells">
            <label class="tooltip-label"
                   matTooltip="Any paid plans will let you set up payment processing to take payments upon booking as well as manage your clients' invoices."
                   [innerHTML]="'AccountSettings.changePlanTableAcceptPayments' | translate | htmlSafe">
            </label>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <!--ABILITY TO SYNC WITH EXTERNAL CALENDARS-->
      <div class="col-md-12 col-sm-12 col-xs-12 pricing-table-comparison-rows"
           *ngIf="planVertical==='general'">
        <div class="row">
          <div class="col-md-2 col-sm-2 col-xs-2 pricing-table-comparison-cells">
            <label class="tooltip-label"
                   matTooltip="The Professional & Business plans let you run a 2-way sync between each of your {{configList['staffLabel'] | titlecase}} members’ TimeTap calendars and their favorite external calendar program. Choose from Google Calendar, iCal, Outlook, or Office 365.">
              2-Way Calendar Sync:
            </label>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <!--ABILITY TO SEND TEXT MESSAGE NOTIFICATIONS-->
      <div class="col-md-12 col-sm-12 col-xs-12 pricing-table-comparison-rows"
           *ngIf="planVertical==='general'">
        <div class="row">
          <div class="col-md-2 col-sm-2 col-xs-2 pricing-table-comparison-cells">
            <label class="tooltip-label"
                   matTooltip="The Business & Professional plans send out text message reminders to clients and sends text message notifications to staff members whenever an appointment is scheduled or cancelled. There is no text messaging available in the Starter (Free) plan."
                   [innerHTML]="'AccountSettings.changePlanTableTextMsgs' | translate | htmlSafe">
            </label>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <!--ABILITY TO ADD UNLIMITED CUSTOM FIELDS-->
      <div class="col-md-12 col-sm-12 col-xs-12 pricing-table-comparison-rows"
           *ngIf="planVertical==='general'">
        <div class="row">
          <div class="col-md-2 col-sm-2 col-xs-2 pricing-table-comparison-cells">
            <label class="tooltip-label"
                   matTooltip="Add as many fields to your booking form as you’d like to and apply them to either your appointment detail screen or your client profile. The Starter (Free) plan will allow you to add up to 3 customizable booking forms."
                   [innerHTML]="'AccountSettings.changePlanTableUnlimitedCustomFields' | translate | htmlSafe">
            </label>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <!--ABILITY TO RUN CUSTOMIZABLE REPORTS-->
      <div class="col-md-12 col-sm-12 col-xs-12 pricing-table-comparison-rows"
           *ngIf="planVertical==='general'">
        <div class="row">
          <div class="col-md-2 col-sm-2 col-xs-2 pricing-table-comparison-cells">
            <label class="tooltip-label"
                   matTooltip="Business & Professional plan holders can export client & appointment reports to Excel over any time frame for any staff or location. Include as many custom fields as you would like to from your booking forms. The Starter (Free) plan only allows you to export appointment lists with limited fields included."
                   [innerHTML]="'AccountSettings.changePlanTableCustomReports' | translate | htmlSafe">
            </label>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <!--PRIVATE URLS PER SERVICE, CLASS, GROUP, STAFF, LOCATION-->
      <div class="col-md-12 col-sm-12 col-xs-12 pricing-table-comparison-rows"
           *ngIf="planVertical==='general'">
        <div class="row">
          <div class="col-md-2 col-sm-2 col-xs-2 pricing-table-comparison-cells">
            <label class="tooltip-label"
                   matTooltip="Business & Professional plans come with private scheduling links & embed codes for each of the {{configList['serviceLabelPlural'] | titlecase}}, {{configList['classLabelPlural'] | titlecase}}, {{configList['staffLabelPlural'] | titlecase}}, & {{configList['locationLabelPlural'] | titlecase}} on your account. Starter (Free) plan only comes with one scheduling page & embed code."
                   [innerHTML]="'AccountSettings.changePlanTablePrivateScheduler' | translate | htmlSafe">
            </label>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <!--ABILITY TO CUSTOMIZE EMAILS-->
      <div class="col-md-12 col-sm-12 col-xs-12 pricing-table-comparison-rows"
           *ngIf="planVertical==='general'">
        <div class="row">
          <div class="col-md-2 col-sm-2 col-xs-2 pricing-table-comparison-cells">
            <label class="tooltip-label"
                   matTooltip="The Business & Professional plans can customize the automated email templates that send out to clients & staff around appointments. They can also edit any email sent out from their account upon sending. Starter (Free) plan holders cannot edit the standard email templates."
                   [innerHTML]="'AccountSettings.changePlanTableCustomEmails' | translate | htmlSafe">
            </label>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <!--ABILITY TO ADD RESOURCES/SHARED ROOMS-->
      <div class="col-md-12 col-sm-12 col-xs-12 pricing-table-comparison-rows"
           *ngIf="planVertical==='general'">
        <div class="row">
          <div class="col-md-2 col-sm-2 col-xs-2 pricing-table-comparison-cells">
            <label class="tooltip-label"
                   matTooltip="If your {{configList['staffLabelPlural'] | titlecase}} has to share rooms in order to offer appointments, you can set those up to keep necessary resources from getting overbooked.">
              <span>Shared Resources:</span>
            </label>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <!--ABILITY TO UPLOAD FILES AND DOCUMENTS-->
      <div class="col-md-12 col-sm-12 col-xs-12 pricing-table-comparison-rows"
           *ngIf="planVertical==='general'">
        <div class="row">
          <div class="col-md-2 col-sm-2 col-xs-2 pricing-table-comparison-cells">
            <label class="tooltip-label"
                   matTooltip="The Business & Professional plans can attach files to client profiles or appointment records to keep up with important documents. There is no file upload available in the Starter (Free) plan.">
              <span>File Upload:</span>
            </label>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
                        <span class="pricing-text">
                            Up to 2Gb
                        </span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
                        <span class="pricing-text">
                            Up to 2Gb
                        </span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
                        <span class="pricing-text">
                            Up to 10Gb
                        </span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
                        <span class="pricing-text">
                            Up to 10Gb
                        </span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <!--ABILITY TO INTEGRATE WITH SALESFORCE-->
      <div class="col-md-12 col-sm-12 col-xs-12 pricing-table-comparison-rows"
           *ngIf="planVertical==='general'">
        <div class="row">
          <div class="col-md-2 col-sm-2 col-xs-2 pricing-table-comparison-cells">
            <label class="tooltip-label"
                   matTooltip="Send {{configList['clientLabel'] | titlecase}} and appointment data directly to your Salesforce account for easier tracking of when leads convert!">
              <span>Salesforce Integration:</span>
            </label>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-times-circle error-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-times-circle error-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <!--DEDICATED TEXT MESSAGE DELIVERY NUMBER-->
      <div class="col-md-12 col-sm-12 col-xs-12 pricing-table-comparison-rows"
           *ngIf="planVertical==='general'">
        <div class="row">
          <div class="col-md-2 col-sm-2 col-xs-2 pricing-table-comparison-cells">
            <label class="tooltip-label"
                   matTooltip="Business level accounts can choose their own number with a custom response for text message notifications to be sent out from">
              <span>Dedicated Text Number:</span>
            </label>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-times-circle error-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-times-circle error-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <!--ABILITY TO ADD VANITY URLS-->
      <div class="col-md-12 col-sm-12 col-xs-12 pricing-table-comparison-rows"
           *ngIf="planVertical==='general'">
        <div class="row">
          <div class="col-md-2 col-sm-2 col-xs-2 pricing-table-comparison-cells">
            <label class="tooltip-label"
                   matTooltip="Turn all the private URLs for each of your services, classes, groups, locations, and staff into friendly URLs to send to your clients. Decide from a list of available domains and customize each of their handles.">
              <span>Vanity URLs:</span>
            </label>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-times-circle error-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-times-circle error-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <!--ABILITY TO ADD A WAIT LIST-->
      <div class="col-md-12 col-sm-12 col-xs-12 pricing-table-comparison-rows"
           *ngIf="planVertical==='general'">
        <div class="row">
          <div class="col-md-2 col-sm-2 col-xs-2 pricing-table-comparison-cells">
            <label class="tooltip-label"
                   matTooltip="When your time gets completely booked up, let clients join a wait list for your services or classes for their preferred day and time. If another client cancels, we'll send any clients on your wait list for that day an email to prompt them to book.">
              <span>Wait List:</span>
            </label>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-times-circle error-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-times-circle error-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <!--ABILITY TO BOOK COURSES-->
      <div class="col-md-12 col-sm-12 col-xs-12 pricing-table-comparison-rows"
           *ngIf="planVertical==='general'">
        <div class="row">
          <div class="col-md-2 col-sm-2 col-xs-2 pricing-table-comparison-cells">
            <label class="tooltip-label"
                   matTooltip="If you offer multi-day seminars or certification programs, courses will let clients enroll into each day of the program in one go through the scheduler.">
              <span>Courses:</span>
            </label>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-times-circle error-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-times-circle error-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <!--ABILITY TO ADD SCREENING QUESTIONS-->
      <div class="col-md-12 col-sm-12 col-xs-12 pricing-table-comparison-rows"
           *ngIf="planVertical==='general'">
        <div class="row">
          <div class="col-md-2 col-sm-2 col-xs-2 pricing-table-comparison-cells">
            <label class="tooltip-label"
                   matTooltip="Make sure your clients meet all the requirements for booking with you before showing them your available times. If they don't meet your requirements, they won't be able to pass through your scheduling flow.">
              <span>Screening Questions:</span>
            </label>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-times-circle error-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-times-circle error-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <!--ABILITY TO ADD FILTERS-->
      <div class="col-md-12 col-sm-12 col-xs-12 pricing-table-comparison-rows"
           *ngIf="planVertical==='general'">
        <div class="row">
          <div class="col-md-2 col-sm-2 col-xs-2 pricing-table-comparison-cells">
            <label class="tooltip-label"
                   matTooltip="Let clients find the nearest staff or location to them based on their zip code or other filter criteria. This is perfect for narrowing down a large list of staff or locations to something manageable for your clients to use.">
              <span>Zip Code Filter:</span>
            </label>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-times-circle error-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-times-circle error-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <span><i class="fa fa-2x fa-check-circle tt-green-text"></i></span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <!--CUSTOM REPORTS BUILT FOR YOUR BUSINESS-->
      <div class="col-md-12 col-sm-12 col-xs-12 pricing-table-comparison-rows"
           *ngIf="planVertical==='general'">
        <div class="row">
          <div class="col-md-2 col-sm-2 col-xs-2 pricing-table-comparison-cells">
            <label class="tooltip-label"
                   matTooltip="Tell our team what information you want to export to a PDF or Excel spreadsheet and we'll build a custom report for you under your Dashboard screen. This could be any combination of client or appointment statistics for any time frame. Custom Reports are added alongside our normal flow of developmental work that our teams deliver on. First request is free with purchase of your Business account; one time fee for each additional report.">
              <span>Reports Built for Your Business:</span>
            </label>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <i class="fa fa-2x fa-times-circle error-text"></i><br>&nbsp;
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <i class="fa fa-2x fa-times-circle error-text"></i><br>&nbsp;
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <i class="fa fa-2x fa-check-circle tt-green-text"></i><br>&nbsp;
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <i class="fa fa-2x fa-check-circle tt-green-text"></i><br>&nbsp;
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <!--CUSTOM SECURITY ROLES-->
      <div class="col-md-12 col-sm-12 col-xs-12 pricing-table-comparison-rows"
           *ngIf="planVertical==='general'">
        <div class="row">
          <div class="col-md-2 col-sm-2 col-xs-2 pricing-table-comparison-cells">
            <label class="tooltip-label"
                   matTooltip="Create unique security access for each one of your staff so that you can restrict which parts of the application they have access to view, add, edit or delete when they login to TimeTap">
              <span>Customized Security Roles:</span>
            </label>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <i class="fa fa-2x fa-times-circle error-text"></i><br>&nbsp;
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <i class="fa fa-2x fa-times-circle error-text"></i><br>&nbsp;
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <i class="fa fa-2x fa-check-circle tt-green-text"></i><br>&nbsp;
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <i class="fa fa-2x fa-check-circle tt-green-text"></i><br>&nbsp;
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <!--INTELLIGENT TRAVEL TIME CALCULATOR-->
      <div class="col-md-12 col-sm-12 col-xs-12 pricing-table-comparison-rows"
           *ngIf="planVertical==='general'">
        <div class="row">
          <div class="col-md-2 col-sm-2 col-xs-2 pricing-table-comparison-cells">
            <label class="tooltip-label"
                   matTooltip="If you take appointments at multiple {{configList['locationLabelPlural'  | titlecase]}} or onsite at a {{configList['clientLabel'] | titlecase}}'s location and need travel time factored into your appointment times, this feature will allow for intelligent travel time routing when {{configList['clientLabelPlural'] | titlecase}} are booking with you.">
              <span>Intelligent Travel Time Calculator:</span>
            </label>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <i class="fa fa-2x fa-times-circle error-text"></i><br>&nbsp;
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <i class="fa fa-2x fa-times-circle error-text"></i><br>&nbsp;
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <i class="fa fa-2x fa-check-circle tt-green-text"></i><br>&nbsp;
            </p>
          </div>
          <div class="col-md-2 col-sm-2 col-xs-2 text-center pricing-table-comparison-cells">
            <p>
              <i class="fa fa-2x fa-check-circle tt-green-text"></i><br>&nbsp;
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <!--FOOTER PLAN UPGRADE/DOWNGRADE BUTTON OPTIONS-->
      <div class="col-md-12 col-sm-12 col-xs-12 pricing-table-comparison-rows"
           *ngIf="planVertical==='general'">
        <div class="row">
          <!--GENERAL INFORMATION SIDE-->
          <div class="col-md-12 pricing-table-comparison-cells pricing-footer"
               style="border-right: none; text-align: center;">
            <p>
                              <span>Can't decide what's right? <span *ngIf="configList['showTimeTapSupportNumber']">Give our support line a call at 202-753-7351</span><span
                                *ngIf="!configList['showTimeTapSupportNumber']">Reach out to us with your questions at <a
                                href="mailto:support@timetap.com" target="_blank">support&#64;timetap.com</a></span> or view the full feature comparison chart:</span>
            </p>
            <a
              href="https://timetap.atlassian.net/wiki/pages/viewpage.action?pageId=7012361#WhatdoesitmeantoupgradefromTimeTapFreetoTimeTapPlus?-comparisonchart"
              target="_blank" class="btn btn-secondary">
              <span [innerHTML]="'AccountSettings.changePlansCompareBtn' | translate | htmlSafe"></span>
            </a>
          </div>
        </div>

      </div>
    </div>
    <div class="clearfix clear-spacing"></div>

  </div>
</div>
<div class="clearfix clear-spacing"></div>
